import React from 'react';
import { Badge } from '@printdeal/ui-library';
import { useSegmentation, isCustomerProgramReseller } from '@printdeal/segmentation/react';

const CustomerProgramsBadge = () => {
  const { data: segmentationData } = useSegmentation();
  if (!segmentationData) {
    return null;
  }

  const { isReseller, isPartOfCustomerProgram, category } = segmentationData;

  if (!isCustomerProgramReseller(isReseller, isPartOfCustomerProgram)) {
    return null;
  }

  return (
    <Badge variant="warning" className="pd-self-start">{category}</Badge>
  );
};

export default CustomerProgramsBadge;
